import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  en: {
    nav_services: "Services", nav_twin: "Digital twin", nav_pricing: "Pricing",
    nav_estimate: "Estimate",
    nav_work: "Our work", nav_agents: "For agents", nav_login: "Client login", nav_book: "Book a call",
    hero_label: "Property care · Mallorca",
    hero_title: "Impeccable care for exceptional homes.",
    hero_sub: "Protection, project management and visualisation for Mallorca's finest properties, each one kept on a single, flawless digital record.",
    hero_cta: "Book a private call", hero_view: "View our work",
    ba_drag: "Drag to reveal", ba_mp: "Matterport + CGI", ba_before: "As it is", ba_after: "The vision",
    manifesto: "Calm, and the quiet certainty that your home is looked after, whether you're on the island or an ocean away.",
    what_we_do: "What we do", pillars_title: "Three disciplines, one standard.",
    protect: "Protect", improve: "Improve", present: "Present",
    protect_h: "Property care", improve_h: "Project management", present_h: "Visualisation",
    protect_p: "Your eyes, hands and trusted local office while you are away.",
    improve_p: "Renovations planned, visualised and delivered end to end.",
    present_p: "Digital twins and CGI that show a home at its very best.",
    explore: "Explore",
    twin_label: "The signature", twin_title: "Every home begins with a digital twin.",
    twin_p: "Not a clipboard audit, a Matterport scan and measured floor plans that become a permanent, accurate record of your property. A living twin you can walk from anywhere in the world.",
    how_label: "How it works", how_title: "From handover to handled.",
    pricing_label: "Pricing", pricing_title: "Clear packages. No surprises.",
    rentnote_a: "Renting it out too?", rentnote_b: "Rental management at 10%", rentnote_c: "- half what most agencies charge.",
    enquire: "Enquire", per_mo: "/mo",
    trust_label: "Trust",
    team_label: "The team", team_title: "Decades on the island, between us.",
    team_sub: "Not a call centre or a franchise, two directors who live here, know the trades, and answer the phone themselves.",
    cta_label: "Book a call", cta_title: "Let's look after your home.",
    cta_p: "A twenty-minute private call, no obligation. We'll talk through your property and exactly what you need.",
    cta_btn: "Request a call",
    form_name: "Your name", form_email: "Email", form_phone: "Phone (optional)", form_msg: "Tell us about your property",
    form_send: "Send request", form_thanks: "Thank you, we'll be in touch within one working day.",
    footer_tag: "Property care, project management and visualisation for Mallorca's international homeowners.",
    insured: "Fully insured · Mallorca · Balearic Islands",
  },
  de: {
    nav_services: "Leistungen", nav_twin: "Der digitale Zwilling", nav_pricing: "Preise",
    nav_estimate: "Angebot",
    nav_work: "Referenzen", nav_agents: "Für Makler", nav_login: "Kunden-Login", nav_book: "Termin buchen",
    hero_label: "Immobilienbetreuung · Mallorca",
    hero_title: "Erstklassige Pflege für außergewöhnliche Häuser.",
    hero_sub: "Schutz, Projektmanagement und Visualisierung für Mallorcas schönste Immobilien, jede in einem einzigen, makellosen digitalen Register.",
    hero_cta: "Privaten Termin buchen", hero_view: "Referenzen ansehen",
    ba_drag: "Ziehen zum Enthüllen", ba_mp: "Matterport + CGI", ba_before: "So wie es ist", ba_after: "Die Vision",
    manifesto: "Ruhe und die stille Gewissheit, dass Ihr Zuhause umsorgt wird, ob auf der Insel oder einen Ozean entfernt.",
    what_we_do: "Was wir tun", pillars_title: "Drei Disziplinen, ein Standard.",
    protect: "Schützen", improve: "Verbessern", present: "Präsentieren",
    protect_h: "Immobilienpflege", improve_h: "Projektmanagement", present_h: "Visualisierung",
    protect_p: "Ihre Augen, Hände und Ihr vertrautes Büro vor Ort, während Sie weg sind.",
    improve_p: "Renovierungen geplant, visualisiert und komplett umgesetzt.",
    present_p: "Digitale Zwillinge und CGI, die ein Zuhause im besten Licht zeigen.",
    explore: "Entdecken",
    twin_label: "Das Markenzeichen", twin_title: "Jedes Zuhause beginnt mit einem digitalen Zwilling.",
    twin_p: "Kein Klemmbrett-Audit, ein Matterport-Scan und vermessene Grundrisse werden zum dauerhaften, präzisen Register Ihrer Immobilie. Ein lebendiger Zwilling, den Sie von überall begehen können.",
    how_label: "So funktioniert es", how_title: "Von der Übergabe zur Rundum-Betreuung.",
    pricing_label: "Preise", pricing_title: "Klare Pakete. Keine Überraschungen.",
    rentnote_a: "Auch vermieten?", rentnote_b: "Vermietungsmanagement zu 10%", rentnote_c: "- die Hälfte der üblichen Agenturgebühr.",
    enquire: "Anfragen", per_mo: "/Mon.",
    trust_label: "Vertrauen",
    team_label: "Das Team", team_title: "Jahrzehnte auf der Insel, gemeinsam.",
    team_sub: "Kein Callcenter, kein Franchise, zwei Direktoren, die hier leben, die Handwerker kennen und selbst ans Telefon gehen.",
    cta_label: "Termin buchen", cta_title: "Kümmern wir uns um Ihr Zuhause.",
    cta_p: "Ein zwanzigminütiges, unverbindliches Gespräch. Wir besprechen Ihre Immobilie und genau das, was Sie brauchen.",
    cta_btn: "Rückruf anfragen",
    form_name: "Ihr Name", form_email: "E-Mail", form_phone: "Telefon (optional)", form_msg: "Erzählen Sie uns von Ihrer Immobilie",
    form_send: "Anfrage senden", form_thanks: "Vielen Dank, wir melden uns innerhalb eines Werktags.",
    footer_tag: "Immobilienpflege, Projektmanagement und Visualisierung für Mallorcas internationale Eigentümer.",
    insured: "Vollversichert · Mallorca · Balearen",
  },
  es: {
    nav_services: "Servicios", nav_twin: "El gemelo digital", nav_pricing: "Precios",
    nav_estimate: "Presupuesto",
    nav_work: "Proyectos", nav_agents: "Para agentes", nav_login: "Acceso clientes", nav_book: "Reservar llamada",
    hero_label: "Cuidado de propiedades · Mallorca",
    hero_title: "Cuidado impecable para hogares excepcionales.",
    hero_sub: "Protección, gestión de proyectos y visualización para las mejores propiedades de Mallorca, cada una en un único registro digital impecable.",
    hero_cta: "Reservar una llamada privada", hero_view: "Ver proyectos",
    ba_drag: "Arrastra para revelar", ba_mp: "Matterport + CGI", ba_before: "Tal como está", ba_after: "La visión",
    manifesto: "Calma y la tranquila certeza de que su hogar está cuidado, esté en la isla o a un océano de distancia.",
    what_we_do: "Qué hacemos", pillars_title: "Tres disciplinas, un solo estándar.",
    protect: "Proteger", improve: "Mejorar", present: "Presentar",
    protect_h: "Cuidado de propiedades", improve_h: "Gestión de proyectos", present_h: "Visualización",
    protect_p: "Sus ojos, manos y oficina local de confianza mientras está fuera.",
    improve_p: "Reformas planificadas, visualizadas y ejecutadas de principio a fin.",
    present_p: "Gemelos digitales y CGI que muestran un hogar en su mejor versión.",
    explore: "Explorar",
    twin_label: "El sello", twin_title: "Cada hogar comienza con un gemelo digital.",
    twin_p: "No una inspección con portapapeles, un escaneo Matterport y planos medidos que se convierten en un registro permanente y preciso de su propiedad. Un gemelo vivo que puede recorrer desde cualquier lugar del mundo.",
    how_label: "Cómo funciona", how_title: "De la entrega al control total.",
    pricing_label: "Precios", pricing_title: "Paquetes claros. Sin sorpresas.",
    rentnote_a: "¿También la alquila?", rentnote_b: "Gestión de alquiler al 10%", rentnote_c: "- la mitad de lo que cobran la mayoría de las agencias.",
    enquire: "Consultar", per_mo: "/mes",
    trust_label: "Confianza",
    team_label: "El equipo", team_title: "Décadas en la isla, entre nosotros.",
    team_sub: "Ni un call center ni una franquicia, dos directores que viven aquí, conocen los oficios y contestan el teléfono ellos mismos.",
    cta_label: "Reservar llamada", cta_title: "Cuidemos de su hogar.",
    cta_p: "Una llamada privada de veinte minutos, sin compromiso. Hablaremos de su propiedad y de exactamente lo que necesita.",
    cta_btn: "Solicitar una llamada",
    form_name: "Su nombre", form_email: "Correo electrónico", form_phone: "Teléfono (opcional)", form_msg: "Cuéntenos sobre su propiedad",
    form_send: "Enviar solicitud", form_thanks: "Gracias, le contactaremos en un día laborable.",
    footer_tag: "Cuidado de propiedades, gestión de proyectos y visualización para propietarios internacionales de Mallorca.",
    insured: "Totalmente asegurada · Mallorca · Islas Baleares",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("solvana_lang") || "en");
  const change = useCallback((l) => { setLang(l); localStorage.setItem("solvana_lang", l); }, []);
  const t = useCallback((k) => dict[lang]?.[k] ?? dict.en[k] ?? k, [lang]);
  return <I18nContext.Provider value={{ lang, setLang: change, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
